/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const reviewOverviewNodes = document.querySelectorAll('.review-overview');

if (reviewOverviewNodes.length > 0) {
    import(/* webpackChunkName: "ReviewOverview" */ './components/ReviewOverview').then(({default: ReviewOverview}) => {
        [...reviewOverviewNodes].forEach((node) => render(
            <ReviewOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
